<!-- Network map: the template of FortinetNetmapComponent.
     The icons are the <symbol> elements just below, used through <use>.
     They're simple stroke drawings: I can replace the content of one
     (keeping its id and viewBox) to change an icon everywhere. -->
<svg class="defs" aria-hidden="true" focusable="false">
  <symbol [attr.id]="uid + '-firewall'" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"></rect><path d="M3 9h18M3 14h18M9 4v5M15 9v5M9 14v6"></path></symbol>
  <symbol [attr.id]="uid + '-globe'" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="M3 12h18M12 3c2.6 2.6 3.8 5.6 3.8 9s-1.2 6.4-3.8 9c-2.6-2.6-3.8-5.6-3.8-9S9.4 5.6 12 3z"></path></symbol>
  <symbol [attr.id]="uid + '-wan'" viewBox="0 0 24 24"><path d="M4 12a8 8 0 0 1 16 0M7.5 12a4.5 4.5 0 0 1 9 0M12 14.5V20"></path><circle cx="12" cy="13" r="1.4"></circle></symbol>
  <symbol [attr.id]="uid + '-switch'" viewBox="0 0 24 24"><rect x="2.5" y="7" width="19" height="10" rx="1.5"></rect><path d="M6 11v2M9 11v2M12 11v2M15 11v2M18 11v2"></path></symbol>
  <symbol [attr.id]="uid + '-tag'" viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8z"></path><circle cx="7.5" cy="8" r="1.5"></circle></symbol>
  <symbol [attr.id]="uid + '-shield'" viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6zM9 12l2 2 4-4"></path></symbol>
  <symbol [attr.id]="uid + '-lock'" viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></symbol>
  <symbol [attr.id]="uid + '-laptop'" viewBox="0 0 24 24"><rect x="5" y="5" width="14" height="10" rx="1.5"></rect><path d="M2.5 19h19l-2-4h-15z"></path></symbol>
  <symbol [attr.id]="uid + '-server'" viewBox="0 0 24 24"><rect x="4" y="3.5" width="16" height="7" rx="1.5"></rect><rect x="4" y="13.5" width="16" height="7" rx="1.5"></rect><path d="M8 7h.01M8 17h.01"></path></symbol>
  <symbol [attr.id]="uid + '-phone'" viewBox="0 0 24 24"><rect x="7" y="2.5" width="10" height="19" rx="2"></rect><path d="M11 18.5h2"></path></symbol>
  <symbol [attr.id]="uid + '-printer'" viewBox="0 0 24 24"><path d="M7 9V3h10v6M7 14h10v7H7z"></path><rect x="3" y="9" width="18" height="8" rx="1.5"></rect></symbol>
  <symbol [attr.id]="uid + '-camera'" viewBox="0 0 24 24"><rect x="3" y="7" width="13" height="10" rx="2"></rect><path d="M16 11l5-3v8l-5-3z"></path></symbol>
  <symbol [attr.id]="uid + '-cloud'" viewBox="0 0 24 24"><path d="M7 18h10a4 4 0 0 0 .6-8 6 6 0 0 0-11.4 1.6A3.3 3.3 0 0 0 7 18z"></path></symbol>
  <symbol [attr.id]="uid + '-ap'" viewBox="0 0 24 24"><path d="M5 9a10 10 0 0 1 14 0M8 12a5.5 5.5 0 0 1 8 0M6 20h12"></path><circle cx="12" cy="15" r="1.3"></circle></symbol>
  <symbol [attr.id]="uid + '-unknown'" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3"></rect><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.4M12 17h.01"></path></symbol>
  <symbol [attr.id]="uid + '-group'" viewBox="0 0 24 24"><path d="M12 6v12M6 12h12"></path></symbol>
</svg>

<div class="card span12 netmap-card" data-ev="card:netmap">
  <div class="card-header has-filter">
    <span class="card-title">Network map</span>
    <span class="hdr-note">
      <ng-container *ngIf="loading">
        <clr-spinner clrInline clrSmall>Loading</clr-spinner> Loading the new window…
      </ng-container>
      <ng-container *ngIf="!loading">
        {{ totalText }}<ng-container *ngIf="coverage">, {{ coverage | lowercase }}</ng-container><span
          class="nm-cut" *ngIf="coverageCut"
          title="Too many sessions to read the whole window: the oldest polls were left out"> (window cut short)</span>.
        Open an interface, then a subnet, to go deeper. A round badge lists the policies of an object.
      </ng-container>
    </span>
    <label class="nm-search">
      <span class="sr-only">Find a host or a subnet</span>
      <input type="search" placeholder="Find an IP, a host name or a subnet"
             [value]="query"
             (input)="setQuery($any($event.target).value)"
             (keyup.enter)="search()">
    </label>
    <button type="button" class="link-btn" (click)="search()">Find</button>
    <button type="button" class="link-btn" *ngIf="found || searchMessage" (click)="clearSearch()">Clear</button>
  </div>

  <div class="empty" *ngIf="!netmap">No session details yet. The map appears after the
    collector's next poll of the session list.</div>

  <ng-container *ngIf="netmap">
    <!-- where I am: device > interface > subnet -->
    <div class="nm-crumbs">
      <button type="button" class="link-btn" (click)="closeTo('device')">{{ deviceTitle }}</button>
      <ng-container *ngIf="openInterface">
        <span aria-hidden="true">›</span>
        <button type="button" class="link-btn" (click)="closeTo('iface')">{{ openInterface }}</button>
      </ng-container>
      <ng-container *ngIf="openSubnet">
        <span aria-hidden="true">›</span>
        <span class="nm-crumb-open">{{ openSubnet }}</span>
      </ng-container>
    </div>
    <p class="nm-message" *ngIf="searchMessage">{{ searchMessage }}</p>

    <div class="nm-scroll">
      <!-- The SVG and the policy card share this box: the SVG is drawn at
           1 unit = 1 px, so the card can be placed with the map coordinates. -->
      <div class="nm-canvas" [style.width.px]="mapWidth" [style.height.px]="mapHeight">
      <svg class="nm-svg" [attr.viewBox]="'0 0 ' + mapWidth + ' ' + mapHeight"
           [attr.width]="mapWidth" [attr.height]="mapHeight"
           role="group" aria-label="Network map">
        <!-- column titles -->
        <text class="nm-col" x="60" y="22" text-anchor="middle">INTERNET</text>
        <text class="nm-col" x="215" y="22" text-anchor="middle">FORTIGATE</text>
        <text class="nm-col" x="462" y="22" text-anchor="middle">INTERFACES</text>
        <text class="nm-col" x="731" y="22" text-anchor="middle" *ngIf="openInterface">SUBNETS</text>
        <text class="nm-col" x="1030" y="22" text-anchor="middle" *ngIf="openSubnet">HOSTS</text>

        <!-- lines first, so the nodes sit on top of them -->
        <path *ngFor="let edge of edges; trackBy: trackByKey" class="nm-edge"
              [ngClass]="'st-' + edge.state"
              [attr.d]="edge.path" [attr.stroke-width]="edge.width"></path>

        <!-- internet and the firewall -->
        <g class="nm-fixed" [attr.transform]="'translate(60 ' + internetY + ')'">
          <circle r="26" class="nm-round"></circle>
          <svg x="-12" y="-12" width="24" height="24" class="nm-icon st-normal"><use [attr.href]="'#' + uid + '-globe'"></use></svg>
          <text y="44" text-anchor="middle" class="nm-label">Internet</text>
        </g>
        <g class="nm-fixed" [attr.transform]="'translate(215 ' + firewallY + ')'">
          <rect x="-60" y="-44" width="120" height="88" rx="14" class="nm-firewall-base"></rect>
          <rect x="-60" y="-44" width="120" height="88" rx="14" class="nm-firewall"></rect>
          <svg x="-14" y="-38" width="28" height="28" class="nm-icon st-normal"><use [attr.href]="'#' + uid + '-firewall'"></use></svg>
          <title>{{ deviceTitle }}<ng-container *ngIf="model"> ({{ model }})</ng-container></title>
          <text y="20" text-anchor="middle" class="nm-label nm-strong">{{ firewallLabel }}</text>
          <text y="34" text-anchor="middle" class="nm-sub nm-mono" *ngIf="model">{{ modelLabel }}</text>
        </g>

        <!-- interfaces, subnets and hosts -->
        <g *ngFor="let node of nodes; trackBy: trackByKey" class="nm-node"
           [ngClass]="['st-' + node.state, 'lv-' + node.level]"
           [class.clickable]="isClickable(node)"
           [class.picked]="isPicked(node)"
           [attr.transform]="'translate(' + node.x + ' ' + node.y + ')'"
           [attr.tabindex]="isClickable(node) ? 0 : null"
           [attr.role]="isClickable(node) ? 'button' : null"
           [attr.aria-label]="node.aria"
           [attr.aria-expanded]="isClickable(node) ? nodeExpanded(node) : null"
           [attr.aria-haspopup]="isClickable(node) && node.target === groupHostsTarget ? 'dialog' : null"
           (click)="isClickable(node) && onNode(node)"
           (keydown)="isClickable(node) && onNodeKey($event, node)">
          <title>{{ node.title }}</title>
          <rect y="-21" height="42" rx="12" class="nm-pill" [attr.width]="node.width"></rect>
          <circle cx="20" r="13" class="nm-badge"></circle>
          <svg x="12" y="-8" width="16" height="16" class="nm-icon"><use [attr.href]="'#' + uid + '-' + node.icon"></use></svg>
          <!-- line 1: label, and the action sign on the right -->
          <text x="40" y="-3" class="nm-label" [class.nm-mono]="node.level !== 'host' || !node.sub">{{ node.labelShown }}</text>
          <text *ngIf="node.mark" [attr.x]="node.width - 12" y="-2" text-anchor="end" class="nm-action">{{ node.mark }}</text>
          <!-- line 2: sub text, and the volume on the right -->
          <text x="40" y="12" class="nm-sub" [class.nm-mono]="node.level === 'host'">{{ node.subShown }}</text>
          <text [attr.x]="node.width - 12" y="12" text-anchor="end" class="nm-sub nm-mono">{{ node.volume }}</text>
        </g>

        <!-- The policy badges, drawn after the nodes so they sit on top.
             They're not inside the node <g> on purpose: a button inside a
             button confuses screen readers, and a click on the badge
             must not also expand the interface. -->
        <g *ngFor="let badge of policyBadges; trackBy: trackByKey" class="nm-badge-pol"
           [class.open]="badge.key === openPolicyKey"
           [attr.transform]="'translate(' + badge.x + ' ' + badge.y + ')'"
           tabindex="0" role="button" [attr.aria-label]="badge.aria"
           [attr.aria-expanded]="badge.key === openPolicyKey"
           (click)="togglePolicyCard(badge.key)" (keydown)="onBadgeKey($event, badge.key)">
          <title>{{ badge.aria }}</title>
          <circle r="9"></circle>
          <text y="3.5" text-anchor="middle">{{ badge.text }}</text>
        </g>
      </svg>

      <!-- the policies of the object whose badge I clicked -->
      <div class="nm-card" *ngIf="policyCard as card" role="dialog"
           [attr.aria-label]="'Policies of ' + card.title"
           [class.above]="card.above"
           [style.left.px]="card.left" [style.top.px]="card.top"
           [style.max-height.px]="card.maxHeight">
        <div class="nm-card-head">
          <div>
            <div class="nm-card-title">{{ card.title }}</div>
          </div>
          <button #policyClose type="button" class="nm-card-close"
                  aria-label="Close" (click)="closePolicyCardByUser()">×</button>
        </div>
        <p class="nm-message" *ngIf="card.note">{{ card.note }}</p>
        <table class="clr nm-pol-tbl" *ngIf="card.rows.length">
          <thead>
            <tr>
              <th>Policy</th>
              <th class="col-route">Interfaces</th>
              <th class="num col-sessions">Sessions</th>
              <th class="num col-volume">Volume</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of card.rows; trackBy: trackByKey">
              <td [title]="row.idText + ' ' + (row.name || '(no name)')">
                <span class="nm-mono">{{ row.idText }}</span>
                <span *ngIf="row.name"> {{ row.name }}</span>
                <span class="dim" *ngIf="!row.name"> (no name)</span>
              </td>
              <td class="nm-mono" [title]="row.routeTitle">{{ row.route }}</td>
              <td class="num">{{ row.sessions }}</td>
              <td class="num">
                <span class="nm-volume">
                  <span class="nm-bar" aria-hidden="true"><span [style.width.%]="row.bar"></span></span>
                  <span class="nm-mono">{{ row.volume }}</span>
                </span>
              </td>
            </tr>
            <tr *ngIf="card.otherText">
              <td class="dim" colspan="4">{{ card.otherText }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>

    <div class="nm-legend">
      <span class="nm-key"><svg width="26" height="8" aria-hidden="true"><path d="M1 4h24" class="nm-edge st-open" stroke-width="3"></path></svg>open path</span>
      <span class="nm-key"><svg width="26" height="8" aria-hidden="true"><path d="M1 4h24" class="nm-edge st-group" stroke-width="3"></path></svg>grouped (not drawn one by one)</span>
      <span class="nm-key"><svg width="26" height="8" aria-hidden="true"><path d="M1 4h24" class="nm-edge st-found" stroke-width="2"></path></svg>search result</span>
      <span class="nm-key"><svg width="26" height="8" aria-hidden="true"><path d="M1 4h24" class="nm-edge st-down" stroke-width="2"></path></svg>link down</span>
      <span class="nm-key"><svg width="20" height="20" aria-hidden="true"><g class="nm-badge-pol" transform="translate(10 10)"><circle r="9"></circle><text y="3.5" text-anchor="middle">3</text></g></svg>policies used (click it)</span>
      <span class="nm-key dim">Line width follows the volume. Hosts are the source addresses of the
        sessions, and their type is a guess from the DHCP host name. The policies are the ones of the sessions opened by these source hosts, in the window.</span>
    </div>
  </ng-container>
</div>

<!-- Every host of a subnet, page by page (GET /hosts.json). The datagrid
     asks for each page itself through clrDgRefresh, so only the page shown
     is downloaded.
     The body is inside *ngIf="panelOpen" on purpose: what I put in a Clarity
     side panel is created with this component even while the panel is
     closed. Without the *ngIf, the datagrid would ask for its first page
     once, at startup (before I opened any subnet), and never again when
     the panel opens, so the list stayed empty. -->
<clr-side-panel [clrSidePanelOpen]="panelOpen" (clrSidePanelOpenChange)="onPanelOpenChange($event)"
                clrSidePanelSize="lg">
  <div class="side-panel-title">
    Hosts of {{ panelSubnet }}
    <span class="nm-panel-sub">on {{ panelInterface }}, {{ panelOrderText }}</span>
  </div>
  <div class="side-panel-body">
    <ng-container *ngIf="panelOpen">
    <div class="nm-panel-search">
      <label class="nm-search">
        <span class="sr-only">Find a host in this subnet</span>
        <input type="search" placeholder="Filter by IP or host name"
               [value]="panelQuery"
               (input)="setPanelQuery($any($event.target).value)"
               (keyup.enter)="searchPanel()">
      </label>
      <button type="button" class="btn btn-sm btn-outline" (click)="searchPanel()">Filter</button>
    </div>
    <p class="nm-message" *ngIf="panelNote">{{ panelNote }}</p>
    <div class="alert alert-danger" role="alert" *ngIf="panelError">
      <div class="alert-items"><div class="alert-item static"><span class="alert-text">{{ panelError }}</span></div></div>
    </div>

    <clr-datagrid (clrDgRefresh)="refreshPanel($event)" [clrDgLoading]="panelLoading" class="nm-hosts">
      <!-- Clarity's own sort headers: clrDgSortBy names the column, and
           refreshPanel sends it to the server, which sorts every host (the
           datagrid only has the page shown). The action column has no data
           to sort on. -->
      <clr-dg-column class="nm-col-rank" [clrDgSortBy]="'rank'" [clrDgSortOrder]="rankSortOrder">#</clr-dg-column>
      <clr-dg-column [clrDgSortBy]="'name'">Host</clr-dg-column>
      <clr-dg-column [clrDgSortBy]="'ip'">IP</clr-dg-column>
      <clr-dg-column [clrDgSortBy]="'bytes'">Volume</clr-dg-column>
      <!-- no sort: it's worked out for the page shown -->
      <clr-dg-column>Policies</clr-dg-column>
      <clr-dg-column class="nm-col-action"><span class="sr-only">Action</span></clr-dg-column>

      <clr-dg-row *ngFor="let row of panelRows; let index = index; trackBy: trackByIp">
        <clr-dg-cell class="nm-col-rank">{{ rankOf(row, index) }}</clr-dg-cell>
        <clr-dg-cell>
          <span class="nm-host-cell">
            <svg width="16" height="16" class="nm-icon st-normal" aria-hidden="true"><use [attr.href]="'#' + uid + '-' + row.kind"></use></svg>
            <span>{{ row.name || '-' }}</span>
          </span>
        </clr-dg-cell>
        <clr-dg-cell class="nm-mono">{{ row.ip }}</clr-dg-cell>
        <clr-dg-cell>
          <span class="nm-volume">
            <span class="nm-bar" aria-hidden="true"><span [style.width.%]="barWidth(row)"></span></span>
            <span class="nm-mono">{{ fmtBytes(row.bytes) }}</span>
          </span>
        </clr-dg-cell>
        <clr-dg-cell><span [title]="policiesTitle(row)">{{ policiesShort(row) }}</span></clr-dg-cell>
        <clr-dg-cell class="nm-col-action">
          <button type="button" class="btn btn-sm btn-link" (click)="showOnMap(row)">Show on map</button>
        </clr-dg-cell>
      </clr-dg-row>

      <clr-dg-placeholder>No host matches.</clr-dg-placeholder>

      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="pageSize" [clrDgTotalItems]="panelTotal">
          <clr-dg-page-size [clrPageSizeOptions]="pageSizes">Hosts per page</clr-dg-page-size>
          {{ pagination.firstItem + 1 }} to {{ pagination.lastItem + 1 }} of {{ panelTotal }} hosts
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
    </ng-container>
  </div>
  <div class="side-panel-footer">
    <button type="button" class="btn btn-outline" (click)="closePanel()">Close</button>
  </div>
</clr-side-panel>
